import React, { useEffect } from "react";
import GaugeChart from 'react-gauge-chart'

interface propData {
  meter: any
}

const Speedometer = (props: propData) => {
  useEffect(() => {

  }, [props.meter])
  return (
    <div key={"125241"}>
      <GaugeChart
        id="gauge-chart1"
        arcWidth={0.4}
        arcPadding={0.01}
        style={{ width: "100%" }}
        percent={props.meter && props.meter == 'Aggressive' ? 0.90 : props.meter == 'Aggressive' ? 0.90 : props.meter == 'Moderately aggressive' ? 0.70 : props.meter == 'Moderate' ? 0.50 : props.meter == 'Moderately conservative' ? 0.30 : 0}
        hideText
        cornerRadius={2}
        nrOfLevels={5}
        colors={["#106409", "#2fb422", "#f4d148", "#FF5F1F", "#bf0e0e"]}
        needleColor="#097ab1"
        needleBaseColor="#097ab1"
        animate={false}
        animateDuration={0}
      />
    </div >
  );
};
export default Speedometer;
